import {Directive, ElementRef, EventEmitter, OnDestroy, Output} from '@angular/core';
import {ResizeObservable} from '../util/dom/resize.observable';
import {Subject, takeUntil} from 'rxjs';

@Directive({
  selector: '[appResize]',
  standalone: false
})
export class ResizeDirective implements OnDestroy {
  private readonly ngUnsubscribe = new Subject<void>();

  @Output() appResize = new EventEmitter<ResizeObserverEntry>();

  constructor(elementRef: ElementRef) {
    new ResizeObservable(elementRef.nativeElement)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resizeObserverEntries => this.appResize.emit(resizeObserverEntries[0]));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
